import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { ToasterServiceService } from '../../service/toaster.service';

@Component({
  selector: 'app-memory-folder-add',
  templateUrl: './memory-folder-add.component.html',
  styleUrl: './memory-folder-add.component.scss'
})
export class MemoryFolderAddComponent {
  GalleryAddForm: any = FormGroup;
  submitted = false;
  subEventId: any;

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterServiceService
  ) {
    this.GalleryAddForm = this.fb.group({
      folder_name: ['', [Validators.required]],
      image_src: ['', [Validators.required]],
    })

    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event'] || '';
    });
  }

  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.GalleryAddForm.controls;
  }

  GalleryFolderAdd() {
    this.submitted = true;
    if (this.GalleryAddForm.valid) {
      let data = {
        gallery_folder_id: 0,
        folder_name: this.GalleryAddForm.value.folder_name,
        //image_src: this.GalleryAddForm.value.image_src, 
        sub_event_id: Number(this.subEventId),
        Action: "INSERT",
      };

      // let formData = new FormData();
      // formData.append('gallery_folder_id','0');
      // formData.append('folder_name', this.GalleryAddForm.value.folder_name);
      // //formData.append('image_src', this.GalleryAddForm.value.image_src);
      // formData.append('sub_event_id', this.subEventId);
      // formData.append('Action','INSERT');

      if (this.GalleryAddForm.valid) {
        this.mainService.putApi(ApiUrls.memoryFolderCreate, data, 1).subscribe((res: any) => {
          if (res.status == 1) {
            this.GalleryAddForm.reset();
            this.submitted = false;
            this.toasterService.toastSuccess(res.response);
            this.router.navigate(["/memory/" + this.subEventId]);
          } else {
            this.toasterService.toastError(res.response);
          }
        })
      }
    }
  }




}
